import React, { useState } from "react";
import { LiveClassIcon } from "../../../core/common/icons/icons";
import LiveClassCard from "./liveClassCard";
import { useHandleLiveClasses } from "../../../core/hooks/useHandleLiveClasses";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { Pagination } from "../../../core/common/ults/pagination";

const LiveClassDashboard = ({ maxItems, enrolledCourses }: any) => {
  const { t } = useTranslation();
  const [selectedCourse, setSelectedCourse] = useState<string>("all");

  const courseList = Array.isArray(enrolledCourses) ? enrolledCourses : [];

  const handleLiveClassesParams = () => {
    if (selectedCourse === "all") {
      const params: any = {};
      if (courseList.length > 0) {
        courseList.forEach((course: any, index: any) => {
          params[`courseids[${index}]`] = course.id;
        });
      }
      return params;
    }
    return {
      "courseids[0]": selectedCourse,
    };
  };

  const liveClassesParams = handleLiveClassesParams();

  const { liveClasses, isLiveClassesLoading } =
    useHandleLiveClasses(liveClassesParams);

  const itemsPerPage = maxItems;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const curentLiveClasses = Array.isArray(liveClasses?.bigbluebuttonbns)
    ? liveClasses.bigbluebuttonbns.slice(startIndex, startIndex + itemsPerPage)
    : [];

  return (
    <div className="live-class-dashboard">
      <div className="section-header mb-3">
        <div className="d-flex flex-column flex-md-row align-items-md-center gap-3 gap-md-0 justify-content-between">
          <h6 className="mb-0">
            <LiveClassIcon className="text-danger me-2" />
            {t("liveClasses.title")}
          </h6>
          <select
            className="form-select"
            style={{ width: "200px" }}
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
          >
            <option value="all">{t("student.events.allCourses")}</option>
            {courseList.length > 0 &&
              courseList.map((course: any) => (
                <option key={course?.id} value={course?.id}>
                  {course?.fullname}
                </option>
              ))}
          </select>
        </div>
      </div>
      {isLiveClassesLoading ? (
        <div className="d-flex justify-content-center py-4">
          <Spin size="large" />
        </div>
      ) : curentLiveClasses.length > 0 ? (
        <div className="row">
          {curentLiveClasses.map((activity: any, index: any) => (
            <div
              key={`compact-${activity.courseId}-${activity.id}-${index}`}
              className="col-12 mb-2"
            >
              <LiveClassCard
                activity={activity}
                courseId={activity.course}
                cmid={activity.coursemodule}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-4">
          <LiveClassIcon className="text-muted fs-48 mb-3 d-block mx-auto" />
          <h6 className="text-muted">{t("liveClasses.noClasses.title")}</h6>
          <p className="text-muted small">{t("liveClasses.noClasses.desc")}</p>
        </div>
      )}
      <Pagination
        totalItems={Array.isArray(liveClasses?.bigbluebuttonbns) ? liveClasses.bigbluebuttonbns.length : 0}
        itemsPerPage={itemsPerPage}
        onPageChange={(page: number) => setCurrentPage(page)}
      />
    </div>
  );
};

export default LiveClassDashboard;
